import HTTP from '@/plugins/http';

const apiUrl = {
  page: '/record/momo/logs/page',
  export: '/record/momo/logs/export',
  contacts: '/merchant/apply/list/page'
};

function getUserContacts(data) {
  return HTTP({
    url: apiUrl.contacts,
    method: 'post',
    data
  });
}

function getPage(params) {
  return HTTP({
    url: apiUrl.page,
    method: 'post',
    ...params
  });
}
function doExport(data) {
  return HTTP.loading({
    url: apiUrl.export,
    method: 'post',
    data,
    responseType: 'blob',
    timeout:600000
  });
}

export default { getPage, doExport, getUserContacts };



// WEBPACK FOOTER //
// ./src/api/logs.js